import { ReactNode } from 'react';
import ReleaseTracker from './ReleaseTracker';

const {
  VITE_PLATFORM_URL: domain,
  VITE_RELEASE_VERSION: releaseVersion,
  VITE_RELEASE_TRACKER_SECONDS: releaseTrackerSeconds,
} = import.meta.env;

interface Props {
  captureException: (error: Error, response?: unknown) => void;
  children: ReactNode;
}

export default function ReleaseTrackerProvider({
  captureException,
  children,
}: Props) {
  return (
    <>
      <ReleaseTracker
        captureException={captureException}
        domain={domain}
        releaseVersion={releaseVersion}
        releaseTrackerSeconds={releaseTrackerSeconds}
      />
      {children}
    </>
  );
}
